<template>
  <div class="news">
    <div id="titleText">
      <h2>
      <span>
        <img class="titleImg" alt="icon" src="../../assets/img/新闻 list.png">
      </span>
        冬奥新闻
      </h2>
    </div>
    <div class="newsBottom">
      <el-timeline>
        <el-timeline-item v-for="(item, index) in newsData"
                          :timestamp="item.date" placement="top"
                          color="#0bbd87">
          <el-card>
            <!--        <h4>{{ item.title }}</h4>-->
            <h4>
          <span>
            <img alt="图标" src="../../assets/img/新闻.png" width="16px" height="18px">
          </span>
              <a :href="item.href" target="_blank">{{ item.title }}</a>
            </h4>
            <p>{{ item.content }}</p>
            <div>新闻来源：<a href="https://www.beijing2022.cn/" target="_blank">@北京冬奥委</a></div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>

  </div>
</template>

<script>
export default {
  name: "News",
  data() {
    return {
      newsData: [
        {
          'title': '“为奥运喝彩”活动再次来到河北 绘青春迎冬奥',
          'content': '6月13日，“为奥运喝彩 恒爱行动·至美之行”第六站在河北美术学院举办。“为奥运喝彩”作为传播奥林匹克精神最为重要的项目之一，其系列活动“恒爱行动·至美之行”再次来到河北，并走进艺术类院校，希望通过奥林匹克精神和中国优秀文化的交流碰撞，促进青年学生对奥林匹克文化的进一步理解、传播和弘扬。',
          'date': '2021-06-14',
          'href': 'https://www.beijing2022.cn/sv1/wog.html?cmsid=20210614001585'
        },
        {
          'title': '划龙舟、逛市集、赏“夜长城”！“冬奥小城”端午很热闹',
          'content': '6月12日至13日，在北京世园公园，第十三届北京端午文化节暨“妫水农耕·世园杯”端午群众龙舟大赛举行。来自北京市延庆区的16支代表队280多名参赛选手在妫河上赛龙舟、健体魄、迎端午，同时也为即将到来的北京冬奥会加油助力。',
          'date': '2021-06-14',
          'href': 'https://www.beijing2022.cn/sv1/wog.html?cmsid=20210614001598'
        },
        {
          'title': '冰雪运动爱好者王蓬：收集冰雪剪报20年 写诗普及冬奥文化',
          'content': '筹办北京冬奥会，激发了亿万群众对于冰雪运动和冬奥文化的热情。近年来，无数工作在各个领域的普通人，因为北京冬奥会的一天天临近，成为冰雪爱好者。',
          'date': '2021-06-14',
          'href': 'https://www.beijing2022.cn/sv1/wog.html?cmsid=20210614001616'
        },        {
          'title': '崇礼太子城冰雪小镇主体结构工程全部结束',
          'content': '近日，崇礼太子城冰雪小镇有轨电车停车库主体结构封顶，标志着该小镇主体结构工程全部结束。',
          'date': '2021-06-12',
          'href': 'https://www.beijing2022.cn/sv1/wog.html?cmsid=EYS2021061200359600'
        },
        {
          'title': '北京冬奥组委与中央广播电视总台签署全媒体宣传合作协议',
          'content': '2021年6月6日上午，北京冬奥组委与中央广播电视总台签署《北京2022年冬奥会和冬残奥会全媒体宣传合作协议》。北京市委书记、北京冬奥组委主席蔡奇出席，并与中宣部副部长、中央广播电视总台台长、总编辑慎海雄，国家体育总局局长、北京冬奥组委执行主席苟仲文，北京市委副书记、市长、北京冬奥组委执行主席陈吉宁，中国残联主席、北京冬奥组委执行主席张海迪以及运动员、志愿者、记者代表共同启动“冬奥来了”全媒体行动。\n' +
              '\n',
          'date': '2021-06-07',
          'href': 'https://www.beijing2022.cn/sv1/wog.html?cmsid=EYS2021060704334000'
        },        {
          'title': '北京冬奥组委暨北京市运行保障指挥部第三次调度会议召开',
          'content': '5月21日下午，北京冬奥组委暨北京市运行保障指挥部第三次调度会议召开，检查各项任务落实情况，研究调度下一步筹办工作。北京市委书记、北京冬奥组委主席蔡奇主持会议，北京市委副书记、市长、北京冬奥组委执行主席陈吉宁，北京市人大常委会主任李伟，北京市政协主席吉林，北京市委副书记张延昆出席。',
          'date': '2021-05-22',
          'href': 'https://www.beijing2022.cn/sv1/wog.html?cmsid=EYS2021052200568400'
        },
        {
          'title': '习近平考察北京冬奥会、冬残奥会筹办工作',
          'content': '1月18日，习近平总书记在北京考察冬奥会、冬残奥会筹办工作。习近平先后来到位于北京市海淀区的首都体育馆和位于北京市延庆区的国家高山滑雪中心、国家雪车雪橇中心考察调研，了解运动场馆建设和运动员参赛备战等情况，看望慰问运动员、教练员和延庆赛区运行保障团队、建设者代表。',
          'date': '2021年01月18日',
          'href': 'https://www.beijing2022.cn/a/20210118/010746.htm'
        }
      ]
    }
  }
}
</script>

<style scoped>
.news {
  position: relative;
  width: 100%;
  height: 100%;

}

#titleText {
  /*background-color: rgba(66, 108, 215, 0.72);*/
  /*background-color: #62D9FF;*/
  width: 100%;
  height: 5% !important;
  position: relative;
  margin: 0 auto;
  padding: 5% 0;
}

#titleText > h2 {
  position: relative;
  margin: 0;
  width: 100%;
  height: 100%;
  text-align: left;
  left: 10%;
  font-size: 2rem;

}

.newsBottom {
  position: relative;
  width: 100%;
  height: 100%;
  /*padding: 0 5%;*/
}

.el-timeline {
  position: relative;

  width: 80%;
  /*left: -10%;*/
  padding-top: 5%;
}

.titleImg {
  width: 1.25rem;
  height: 1.25rem;
  margin: 0 auto;
}

/deep/ .el-card__body {
  border-radius: 10px;
}

.el-card__body > h4 {
  margin-top: 0;
  text-align: left;
  cursor: pointer;
}

.el-card__body > h4 > a {
  border-bottom: 1px solid #6e6ee4;
  text-decoration: none;
  cursor: pointer;
  color: #02a6b5;
}

.el-card__body > h4 > span {
  margin-right: 5px;
}

.el-card__body > p {
  text-align: left;
  text-indent: 2em;
  /*margin-bottom: 0;*/
}

.el-card__body > div {
  text-align: right;
}
</style>
